function App() {
  // Return null to let the static HTML in public/index.html render
  return null;
}

export default App;
